// extracted by mini-css-extract-plugin
export default {"container":"StoreDeliveryNoteItem_container__oJcW1","storeName":"StoreDeliveryNoteItem_storeName__YydXn","note":"StoreDeliveryNoteItem_note__zPh7S"};